"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { UnitVolumesByTermProps } from "./UnitVolumesByTermChart.impl";

export const UnitVolumesByTermChart = dynamicChart(
  () => import("./UnitVolumesByTermChart.impl").then((m) => m.UnitVolumesByTermChart),
  320,
);
